import { YaysonPresenter } from './../../../model-repository'
import { QuestionPresenter, TestExecutionPresenter } from '..'

const TYPE = 'user-questions'

export class UserQuestionPresenter extends YaysonPresenter {

  public type: string = TYPE

  public attributes(modelData) {
    return {
      'time-spent': modelData['time-spent'],
      'flagged': modelData['flagged']
    }
  }

  public relationships() {
    return {
      'question': QuestionPresenter,
      'test-execution': TestExecutionPresenter
    }
  }
}

UserQuestionPresenter.prototype.type = TYPE



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/presenters/user-question/user-question.presenter.ts